// extracted by mini-css-extract-plugin
module.exports = {"popupContainer":"e_Yp","popupBlock":"e_Zp"};